module.exports = __webpack_public_path__ + "img/kv_deco.a666fbaa.webp";